var _defs, _polyline, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZigzag1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.61 21.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #5d3dc0;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: ".74 9.74 7.64 2.08 13.09 9.55 18.93 2.08 24.3 9.26 30.04 1.89 35.69 9.26 41.72 1.89 47.08 9.36 52.64 1.89 58.19 9.26 63.74 2.08 69.49 9.16 75.23 1.7 80.79 9.74"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: ".74 19.74 7.64 12.08 13.09 19.55 18.93 12.08 24.3 19.26 30.04 11.89 35.69 19.26 41.72 11.89 47.08 19.36 52.64 11.89 58.19 19.26 63.74 12.08 69.49 19.16 75.23 11.7 80.79 19.74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigzag1);
export default __webpack_public_path__ + "static/media/zigzag-1.c7250116dcc289592551614797e2b951.svg";
export { ForwardRef as ReactComponent };